// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__2kCgy","card":"home_card___GE3F","glingling":"home_glingling__QbDrc"};